export default {
  // Header & navigation
  'header.eyebrow': 'Online ordering',
  'nav.info': 'Info',
  'nav.cart': 'Cart',
  'nav.menu': 'Menu',

  // Menu
  'menu.loading': 'Loading menu...',
  'menu.error': 'Failed to load menu:',
  'menu.empty': 'No items available.',

  // Cart
  'cart.title': 'Cart',
  'cart.empty': 'Your cart is empty.',
  'cart.total': 'Total',
  'cart.checkout': 'Proceed to Checkout',
  'cart.back': 'Back to Menu',
  'cart.fab': 'Cart ({count}) — {total} €',
  'cart.view': 'View cart',

  // Complement picker
  'picker.selectMultiple': '(select multiple)',
  'picker.selectOne': '(select one)',
  'picker.addToCart': 'Add to Cart',
  'picker.note': 'Note for this item',
  'picker.notePlaceholder': 'e.g. no onions, extra sauce...',
  'picker.quantity': 'Quantity',

  // Checkout
  'checkout.title': 'Checkout',
  'checkout.back': 'Back',
  'checkout.timingTitle': 'Delivery time',
  'checkout.timingAsap': 'As soon as possible',
  'checkout.timingScheduled': 'Schedule for later',
  'checkout.scheduleDate': 'Date',
  'checkout.scheduleTime': 'Time',
  'checkout.scheduleHint': 'At least 1 hour ahead, within working hours.',
  'checkout.scheduleRequired': 'Please pick a delivery date and time.',
  'checkout.scheduleNoSlots': 'No slots available for the selected date.',
  'checkout.scheduleNoDays': 'No open days available for scheduling.',
  'step.contact': 'Contact details',
  'step.timing': 'Delivery time',
  'step.payment': 'Payment',
  'step.next': 'Continue',
  'checkout.name': 'Full name',
  'checkout.address': 'Delivery address',
  'checkout.floor': 'Floor / apartment',
  'checkout.phone': 'Phone',
  'checkout.email': 'Email address',
  'checkout.emailInvalid': 'Please enter a valid email address.',
  'checkout.note': 'Order note',
  'checkout.submit': 'Place Order',
  'checkout.submitting': 'Submitting order...',
  'checkout.items': 'Items',
  'checkout.deliveryFee': 'Delivery',
  'checkout.total': 'Total',
  'checkout.free': 'Free',
  'checkout.fillRequired': 'Please fill in all required fields.',
  'checkout.noLocation': 'No delivery location configured. Please contact the restaurant.',
  'checkout.paymentCash': 'Cash',
  'checkout.paymentCard': 'Card',
  'checkout.minimumOrder': 'Minimum order for zone "{zone}" is {min} €. Your order: {amount} €.',

  // Order status
  'status.pending': 'Your order has been received. Waiting for confirmation...',
  'status.pendingDelayed': 'Your scheduled order for {when} has been received.',
  'status.pendingDelayedEmail': "The restaurant will review it before delivery and you'll receive a confirmation by email.",
  'status.approved': 'Order approved!',
  'status.approvedEta': 'Estimated delivery time: ~{minutes} min',
  'status.approvedDelayed': "Scheduled delivery: {when}. We'll do our best to deliver at the scheduled time.",
  'status.rejected': 'Order rejected.',
  'status.rejectedReason': 'Reason: {reason}',
  'status.newOrder': 'New Order',

  // Closed overlay / banner
  'closed.title': 'Closed',
  'closed.paused': 'Online orders are currently paused.',
  'closed.outsideHours': 'Online orders are not available right now.',
  'closed.schedule': 'Working hours',
  'banner.closed': 'The restaurant is currently closed. You can browse the menu or schedule an order for later.',
  'banner.paused': "We're busy and can't take ASAP orders right now. You can still schedule an order for later.",

  // Info page
  'info.title': 'Information',
  'info.deliveryZones': 'Delivery Zones',
  'info.zoneMin': 'Min',
  'info.zoneFee': 'Delivery',
  'info.zoneFree': 'Free',
  'info.openingHours': 'Opening Hours',
  'info.deliveryHours': 'Delivery Hours',
  'info.pickupHours': 'Pickup Hours',
  'info.paymentMethods': 'Payment Methods',
  'info.address': 'Address',
  'info.phone': 'Phone',
  'info.languages': 'Language',
  'info.back': 'Back',

  // Reservation
  'reservation.title': 'Table Reservation',
  'reservation.notAccepting': 'We are not currently taking reservations.',
  'reservation.guests': 'Number of guests',
  'reservation.guestsPlaceholder': 'Select number of guests',
  'reservation.date': 'Date',
  'reservation.time': 'Time',
  'reservation.name': 'Full name',
  'reservation.phone': 'Phone',
  'reservation.note': 'Note',
  'reservation.notePlaceholder': 'additional notes (optional)',
  'reservation.submit': 'Reserve',
  'reservation.submitting': 'Submitting...',
  'reservation.fillRequired': 'Please fill all required fields.',
  'reservation.pending': 'Your request has been received. Waiting for confirmation...',
  'reservation.approved': 'Reservation confirmed!',
  'reservation.rejected': 'Reservation declined.',

  // Delivery time notice
  'delivery.minTime': 'Current minimum delivery time: ~{minutes} min',

  // Days
  'day.0': 'Monday',
  'day.1': 'Tuesday',
  'day.2': 'Wednesday',
  'day.3': 'Thursday',
  'day.4': 'Friday',
  'day.5': 'Saturday',
  'day.6': 'Sunday',
} as const;
